import type {
    CreateLawFirmPayload,
    LawFirm,
    LawFirmIntakeOptionsUpdate,
    UpdateLawFirmPayload,
} from '@common/types/lawfirms';
import axiosInstance from '@/services/axiosInstance';

export async function fetchAllLawFirms(includeTestFirms = true) {
    const response = await axiosInstance.get<LawFirm[]>('/api/v1/lawfirms', {
        params: { includeTestFirms },
    });
    return response.data;
}

export async function fetchLawFirmById(id: number) {
    const response = await axiosInstance.get<LawFirm>(`/api/v1/lawfirms/${id}`);
    return response.data;
}

export async function fetchLawFirmList() {
    const response = await axiosInstance.get<LawFirm[]>('/api/v1/lawfirms/admin-list');
    return response.data;
}

export async function createLawFirm(payload: CreateLawFirmPayload) {
    const response = await axiosInstance.post<LawFirm>('/api/v1/lawfirms', payload);
    return response.data;
}

export async function updateLawFirm(lawFirmId: number, payload: UpdateLawFirmPayload) {
    const response = await axiosInstance.put<LawFirm>(`/api/v1/lawfirms/${lawFirmId}`, payload);
    return response.data;
}

export async function updateLawFirmIntakeOptions(
    lawFirmId: number,
    options: LawFirmIntakeOptionsUpdate,
) {
    const response = await axiosInstance.put<LawFirm>(
        `/api/v1/lawfirms/${lawFirmId}/intake-options`,
        options,
    );
    return response.data;
}

export async function updateLawFirmLogo(lawFirmId: number, fileId: string) {
    return axiosInstance.put(`api/v1/lawfirms/logo/${lawFirmId}`, fileId, {
        headers: { 'Content-Type': 'application/json' },
    });
}
